
import React from "react";

export {AppLevelError};

const AppLevelError = (props: any) => {
    return(<>The application is currently not available</>)
}